import CommComposeFeeReminder from './CommComposeFeeReminder'
import CommComposeAttendance from './CommComposeAttendance'
import CommComposeHomework from './CommComposeHomework'
import CommComposeExams from './CommComposeExams'
import CommComposeGeneric from './CommComposeGeneric'

const CODE_MAP = {
  fee: CommComposeFeeReminder,
  fee_reminder: CommComposeFeeReminder,
  fees: CommComposeFeeReminder,
  attendance: CommComposeAttendance,
  homework: CommComposeHomework,
  exam: CommComposeExams,
  exams: CommComposeExams,
  results: CommComposeExams,
  exam_results: CommComposeExams,
}

// Created By Cursor
export function resolveComposeComponent(service) {
  if (!service) return CommComposeGeneric

  const code = String(service.service_code || '')
    .toLowerCase()
    .trim()
    .replace(/[\s-]+/g, '_')
  if (code && CODE_MAP[code]) return CODE_MAP[code]

  const haystack = [
    service.service_code,
    service.service_name,
    service.group_name,
  ]
    .map((v) => String(v || '').toLowerCase())
    .join(' ')

  if (/\bfee/.test(haystack) || /payment/.test(haystack)) {
    return CommComposeFeeReminder
  }
  if (/attendance/.test(haystack)) return CommComposeAttendance
  if (/homework|academic/.test(haystack)) return CommComposeHomework
  if (/exam|result/.test(haystack)) return CommComposeExams

  return CommComposeGeneric
}

export default resolveComposeComponent
